/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserInfoRequest = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
